export default __webpack_public_path__ + "static/media/checkGreen.39b54eee.svg";